import { useState, useEffect, useRef } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'pt', label: 'Português' },
]

export default function LanguageSwitcher() {
  const { lang } = useParams()
  const { pathname } = useLocation()
  const { i18n } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  const SUPPORTED = ['en', 'es', 'pt']
  const rawLang = i18n.language?.slice(0, 2)
  const currentLang = lang && SUPPORTED.includes(lang) ? lang : (SUPPORTED.includes(rawLang) ? rawLang : 'en')
  const actualLang = lang && SUPPORTED.includes(lang) ? lang : undefined

  useEffect(() => {
    if (!open) return
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [open])

  const switchTo = (code) => {
    if (code === currentLang) return
    const targetPath = actualLang
      ? pathname.replace(`/${actualLang}`, `/${code}`)
      : `/${code}${pathname}`
    i18n.changeLanguage(code)
    window.location.href = targetPath
  }

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        onClick={() => setOpen(!open)}
        className="btn btn-outline btn-sm"
        title="Language"
        style={{ padding: '0.375rem', lineHeight: 0, cursor: 'pointer' }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
        <span style={{ marginLeft: '0.25rem', fontSize: '0.7rem', fontWeight: 600, lineHeight: 1, textTransform: 'uppercase' }}>{currentLang}</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          marginTop: '0.375rem',
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: '6px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
          zIndex: 200,
          minWidth: '120px',
          overflow: 'hidden',
        }}>
          {LANGUAGES.map(lang => (
            <button
              key={lang.code}
              onClick={() => { setOpen(false); switchTo(lang.code) }}
              style={{
                display: 'block',
                width: '100%',
                padding: '0.5rem 0.75rem',
                border: 'none',
                background: lang.code === currentLang ? 'var(--bg-hover)' : 'transparent',
                color: 'var(--text)',
                cursor: 'pointer',
                fontSize: '0.8125rem',
                textAlign: 'left',
                fontWeight: lang.code === currentLang ? 600 : 400,
              }}
              onMouseEnter={e => e.target.style.background = 'var(--bg-hover)'}
              onMouseLeave={e => e.target.style.background = lang.code === currentLang ? 'var(--bg-hover)' : 'transparent'}
            >
              {lang.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
